import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import ContentsWrap from 'components/molecules/ContentsWrap';
import Highchart from 'components/organisms/Chart/Highchart';
import { getDatesStartToLast } from 'lib/commonLib';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  barGraphBox: {
    width: '100%',
    boxSizing: 'border-box',
  },
}));

const BrowserDayGraph = (props) => {
  const { t } = useTranslation();
  const { params, barData, graphOptionList, loading } = props;
  const classes = useStyles();

  //하이차트 기본설정
  const initOptions = {
    chart: {
      type: '',
    },
    colors: [
      '#7CB5EC',
      '#e0e0e0',
      '#90ED7D',
      '#F7A35C',
      '#268b1f',
      '#F15C80',
      '#E4D354',
      '#8085E8',
      '#8D4653',
    ],
    xAxis: {
      categories: [],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
      series: {
        stacking: 'normal',
      },
    },
    tooltip: {
      shared: true,
      formatter: function () {
        let points = this.points;
        let pointsLength = points.length;
        let tooltipMarkup = '<span>' + points[0].key + '</span><br/>';
        let index;
        let pointVal;
        let pointValFormat;

        for (index = 0; index < pointsLength; index += 1) {
          pointVal = points[index].y;
          pointValFormat = pointVal.toLocaleString(undefined, {
            maximumFractionDigits: 5,
          });
          tooltipMarkup += '<div style="position: relative;width:100%;">';
          tooltipMarkup +=
            '<div style="color:' +
            points[index].series.color +
            ';display:inline-block;width:85px;">\u25CF ' +
            points[index].series.name +
            ': </div>';
          tooltipMarkup +=
            '<span style="color:black;font-weight: bold">' +
            ((pointVal / points[0].total) * 100).toFixed(1) +
            '% </span>';
          tooltipMarkup +=
            '<span style="color:black;">(' + pointValFormat + ')</span>';
          tooltipMarkup += '</div>';
        }

        return tooltipMarkup;
      },
      useHTML: true,
      style: {
        zIndex: 10001,
      },
    },
    series: [],
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'top',
    },
    credits: {
      enabled: false, //하단 로고 삭제
    },
    exporting: {
      enabled: false,
    },
  };

  const [graphList, setGraphList] = useState([]);

  useEffect(() => {
    if (barData !== undefined) {
      // 그래프 X축 카테고리 날짜
      let categories = getDatesStartToLast(
        params.sDate,
        params.eDate,
        'YYYYMMDD'
      );
      let graphKeyArray = barData.day.data;
      let newGraphList = [];
      let tmpSeries = [];

      let tempGraphOption = { ...initOptions };
      let selectChartType = !!graphOptionList
        ? `${graphOptionList.chart.type}`
        : 'column';

      graphKeyArray.forEach((row) => {
        let daySeries = Array.from({ length: categories.length }, () => 0);
        for (let i = 0; i < categories.length; i++) {
          row.data.forEach((item) => {
            if (categories[i] === item.name.toString()) {
              daySeries[i] = item.val;
            }
          });
        }
        tmpSeries.push({
          name: row.title,
          data: daySeries,
        });
      });
      newGraphList.push({
        ...tempGraphOption,
        chart: {
          type: selectChartType,
        },
        xAxis: {
          categories: categories,
        },
        yAxis: {
          min: 0,
          title: {
            text: barData.title,
          },
        },
        title: {
          text: t(''),
        },
        series: tmpSeries,
      });
      setGraphList(newGraphList);
    } // eslint-disable-next-line
  }, [barData]);

  /**
   * 그래프용 데이터 가공
   */
  const makeGraphData = useCallback(
    (graphList) => {
      const result = [];
      for (let i in graphList) {
        result.push(
          <div key={i} className={classes.barGraphBox}>
            <Highchart options={graphList[i]} />
          </div>
        );
      }
      return result;
    }, // eslint-disable-next-line
    []
  );
  return (
    <>
      <ContentsWrap contentsCount={1} loading={loading}>
        {makeGraphData(graphList)}
      </ContentsWrap>
    </>
  );
};

const equalComparison = (prevProps, nextProps) => {
  if (JSON.stringify(prevProps.params) !== JSON.stringify(nextProps.params)) {
    return false;
  }
};

BrowserDayGraph.propTypes = {
  params: PropTypes.object.isRequired,
};
export default React.memo(BrowserDayGraph, equalComparison);
